module.exports = __webpack_public_path__ + "img/page-not-found.e2865583.png";